import React from 'react';

import { Route, RouteProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import NestedRedirect from 'components/NestedRedirect';

import { useAuth } from 'hooks/useAuth';

const ProtectedRoute = (props: RouteProps) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <Route {...props} />
  ) : (
    <NestedRedirect to="/sign-in" />
  );
};

export default compose(withRouter)(ProtectedRoute);
